import { Component, inject, effect, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ApplicationStore } from '@core/stores/application.store';
import { TranslateModule } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { signalMethod } from '@ngrx/signals';

@Component({
  selector: 'app-root',
  imports: [
    RouterModule,
    MatProgressSpinnerModule,
    TranslateModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.component.html'
})
export class AppComponent {

  readonly applicationStore = inject(ApplicationStore);
  readonly snackBar = inject(MatSnackBar);

  readonly showApplicationErrors = signalMethod<Error | undefined>((lastApplicationError) => {
    if (!lastApplicationError) {
      return;
    }
    if ('status' in lastApplicationError && (lastApplicationError as { status: number }).status === 401) {
      return;
    }
    this.snackBar.open(lastApplicationError.message);
  });

  constructor() {
    this.showApplicationErrors(this.applicationStore.lastApplicationError);
    effect(() => {
      const authenticated = this.applicationStore.authenticated();

      document.body.classList.add("overflow-hidden");
      if(authenticated) {
        document.body.classList.remove("overflow-hidden");
      }
    });
  }
}
